import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgbdModalConfirm } from './services/utils/modal-confirm';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule
  ],
  declarations: [
    NgbdModalConfirm
  ],
  providers: [
  ],
  exports: [
  ],
  entryComponents: [
    NgbdModalConfirm,
  ]
})
export class CoreModule {}
